import { config } from '@fortawesome/fontawesome-svg-core';

// Configure FontAwesome
// without this class, SVGs are displayed inline as of Font Awesome 7
// https://docs.fontawesome.com/upgrade/whats-changed#fixed-width-icons-by-default
config.replacementClass = 'fa-width-auto';
